
import { Component, Prop, Vue } from 'vue-property-decorator';
import MessageListItem from '@/components/message/MessageListItem.vue';
import { Toast } from 'vant';
import { FirstPageInfoItem } from '@/interfaces/websocketMessageInterfaces';
import AdManageApi from '@/apis/advertManage/admanage';
import i18n from '@/lang';

@Component({
  components: {
    MessageListItem
  }
})
export default class KtpMessage extends Vue {
  private data: FirstPageInfoItem[] = this.wsMsgModule.firstPageInfoList || [];
  private loadingStatus: boolean = true;
  private adObject:any = null;
  private adShow:boolean = false;
  private adObjectLists:any = [];//广告列表
  private animate:boolean = false;
  private impressionsMap = new Map();//是否被曝光过

  created() {
    this.data = [];
    if (this.wsMsgModule.loginParam) {
      this.wsMsgModule.loginParam.pageCurrent = 1;
      this.wsMsgModule.login(this.wsMsgModule.loginParam);
    }
    this.loadingStatus = true;
    this.wsMsgModule.onLogin = (param: FirstPageInfoItem) => {
      if(param != null){
        this.data = this.data.concat(param);
      }
      this.loadingStatus = false;
    };
    this.wsMsgModule.onGetMessage = (param: any) => {
      this.wsMsgModule.login(this.wsMsgModule.loginParam);
    };
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    try {
      Toast.clear();
    } catch (e:any) {
      console.log(e);
    }
    next();
  }

  mounted() {
    if(this.$parent != null && this.$parent.$el != null){
      this.$parent.$el.addEventListener('scroll', this.getMessageList);
    }
    this.$setNavInfo({
      btnSplitLine: false,
      showBackIcon: false,
      btnGroup: [
        {
          text: i18n.t('message.通讯录') as string,
          callback: () => {
            this.$router.push('/addressBooks');
          },
          type: 'text',
          customStyle: {
            color: '#4285F4'
          }
        }
      ],
      backConfig: () => {
        this.$router.push('/ktpCourse');
      }
    });
    this.getAdByLocation();
  }

  // 获取消息列表
  getMessageList() {
    if (this.wsMsgModule.friendTotal > this.data.length
      && this.data.length > (this.wsMsgModule.loginParam.pageCurrent - 1) * this.wsMsgModule.loginParam.pageSize
      && this.$parent
      && this.$parent.$el.scrollTop + this.$parent.$el.clientHeight + 200 > this.$parent.$el.scrollHeight) {
      this.wsMsgModule.loginParam.pageCurrent++;
      this.wsMsgModule.login(this.wsMsgModule.loginParam);
    }
  }

  beforeDestroy() {
    if(this.$parent != null && this.$parent.$el != null){
          this.$parent.$el.removeEventListener('scroll', this.getMessageList);
    }
  }

  /**
   * 项删除成功
   */
  deleteItemSucc(groupId:string){
    for(let i=0;i<this.data.length;i++){
      if(this.data[i]['group']['id'] == groupId){
        this.data.splice(i,1);
        this.$forceUpdate();
        break;
      }
    }
  }

  //获取广告的列表
  getAdByLocation(){
    AdManageApi.getAdByLocation({location:2,maxShowCount:3}).then((res:any)=>{
      this.adObject = res.ad;
      this.adObjectLists = res.adLists;//广告的列表
      if(this.adObjectLists && this.adObjectLists.length>0){
        this.adShow = true;
        this.animate = false;
        if(this.adObjectLists.length > 1){
          this.getScrollMessage();
        }else{
          let firstItem = this.adObjectLists[0];
          AdManageApi.collectAdLog({adid:firstItem.id,corpid:firstItem.corpid,type:1,location:2}).then((res1:any)=>{
          });
        }
        AdManageApi.collectPageLog({location:2});
      }
    });
  }

  //跳转到某个广告
  gotoAd(adObject:any){
    let item = adObject;
    //私信行为
    AdManageApi.collectAdLog({adid:item.id,corpid:item.corpid,type:2,location:2}).then((res1:any)=>{
        if(item.jumptype == 2 && item.jumpurl != ""){
            this.openNewWindow(item.jumpurl);
        }
    });
  }

  scroll() {
      this.animate = true; // 为true时将动画样式赋值给布局，见布局处引用
      setTimeout(() => {
        //  这里直接使用了es6箭头写法，省去了处理this指向偏移问题
        this.adObjectLists.push(this.adObjectLists[0]); // 将数组的第一个元素添加到数组的
        this.adObjectLists.shift(); //删除数组的第一个元素
        this.animate = false; // margin-top为0的时候取消过渡动画，实现无缝滚动
      }, 200);//每条滚动时长0.5s
      //滚动到当前了
      let firstItem = this.adObjectLists[0];
      if(!this.impressionsMap.get(firstItem.id)){
        this.impressionsMap.set(firstItem.id,1);
        //收集曝光的日志
        AdManageApi.collectAdLog({adid:firstItem.id,corpid:firstItem.corpid,type:1,location:2}).then((res1:any)=>{
        });
      }
  }

  getScrollMessage(){
      if(this.adObjectLists && this.adObjectLists.length>0){
        let firstItem = this.adObjectLists[0];
        if(!this.impressionsMap.get(firstItem.id)){
          this.impressionsMap.set(firstItem.id,1);
          //收集曝光的日志
          AdManageApi.collectAdLog({adid:firstItem.id,corpid:firstItem.corpid,type:1,location:2}).then((res1:any)=>{
          });
        }
      }
      //这里用网络请求替换真实数据，把下面的代码放到响应成功的线程里
      setInterval(this.scroll, 3000);
  }

}
